import React, { useContext, useState, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';
import toast from 'react-hot-toast';

import { DataContext } from '../../init/getData';
import { Space, Table, Tag, Button } from 'antd';

import { numberFormatter } from '../formatters/numberFormatter';




const InvoiceJv = (props) => {

    const { showModal, toggleModal, title, transactions } = props;

    const { api, userData, settingData, currencyData, auxAccountData, warehouseData, mainCurrency, secondaryCurrency, rateToSecondaryCurrency } = useContext(DataContext);
    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;



    const updatedTransactions = transactions.map(transaction => {

        // Find the account with the matching accountId
        const account = auxAccountData.find(acc => acc.id === transaction.accountId);
        const warehouse = warehouseData.find(acc => acc.id === transaction.warehouseId);

        // If account exists, add the accountName field
        return {
            ...transaction,
            accountName: account ? account.english : '-',
            warehouseName: warehouse ? warehouse.name : '-',
            accountId: account?.parent?.accountId && account?.accountId
                ? `${account.parent.accountId}.${account.accountId}`
                : '-'
        };
    });

    const totalDebit = updatedTransactions.reduce((sum, currentItem) => sum + parseFloat(currentItem.debit), 0);

    const totalCredit = updatedTransactions.reduce((sum, currentItem) => sum + parseFloat(currentItem.credit), 0);


    const columns = [
        {
            title: 'Type',
            dataIndex: 'type',
        },
        {
            title: 'Account',
            dataIndex: 'accountId',
        },
        {
            title: 'Name',
            dataIndex: 'accountName',
        },
        {
            title: 'Debit',
            dataIndex: 'debit',
            render: numberFormatter,
        },
        {
            title: 'Credit',
            dataIndex: 'credit',
            render: numberFormatter,
        },
        {
            title: 'Rate',
            dataIndex: 'rate',
            render: numberFormatter,
        },
        {
            title: 'Debit ' + mainCurrency?.code,
            dataIndex: 'totalDebit',
            render: numberFormatter,
        },
        {
            title: 'Credit ' + mainCurrency?.code,
            dataIndex: 'totalCredit',
            render: numberFormatter,
        },
        ...(secondaryCurrency ? [
            {
                title: 'Debit ' + secondaryCurrency?.code,
                dataIndex: 'secondaryTotalDebit',
                render: numberFormatter,
            },
            {
                title: 'Credit ' + secondaryCurrency?.code,
                dataIndex: 'secondaryTotalCredit',
                render: numberFormatter,
            }
        ] : []),
        {
            title: 'warehouse',
            dataIndex: 'warehouseName',
        },
    ]

    return (

        <div>
            <Table columns={columns} dataSource={updatedTransactions} pagination={false} />
            <p>{totalDebit}={totalCredit}</p>
        </div>

    )
}


export default InvoiceJv;